import SettingsNav from 'components/settings/SettingsNav';
import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './SettingsLayout.module.scss';

const SettingsLayout: React.FC = () => {
  return (
    <div className={styles.layout}>
      <SettingsNav />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default SettingsLayout;
